export function WelcomePage() {
  return <div>Zombor buzi</div>;
}
